module.exports = __webpack_public_path__ + "img/img59.c060994b.png";